import { BaseApiService } from '@services/baseApiService';
import { RoleOutputDTO } from '@types';
import { ApiResponse, ApiError } from '@/types/api';

class RoleService extends BaseApiService<RoleOutputDTO> {
  constructor() {
    super('roles');
  }

  async create(data: Partial<RoleOutputDTO>): Promise<ApiResponse<RoleOutputDTO> | ApiError> {
    // Remove sensitive data if needed
    const roleData = {
      ...data,
    };
    
    return await super.create(roleData);
  }

  async update(id: string, data: Partial<RoleOutputDTO>): Promise<ApiResponse<RoleOutputDTO> | ApiError> {
    // Remove sensitive data if needed
    const roleData = {
      ...data,
    };
    
    return await super.update(id, roleData);
  }

  // You can add role-specific methods here if needed
}

export const roleService = new RoleService(); 